import { render, staticRenderFns } from "./SharedMediaTable.vue?vue&type=template&id=5d1d59f5&"
import script from "./SharedMediaTable.vue?vue&type=script&lang=js&"
export * from "./SharedMediaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports